/**
 * Shared icon-size tokens for the compact controls inside ManageSubscriptionsModal (the
 * product panel's chevron toggle and trash button, the "+ Add Product" trigger, and the
 * header account menu).
 *
 * Values come from the PANWDS icon scale (xxs 10 / xs 12 / sm 14 / md 16 / lg 20) and are
 * chosen against the affordances PANWDS itself sizes the same way, so our custom controls
 * stay consistent with the design system rather than drifting to whatever looked closest:
 *   - `AccordionPanel`'s chevron indicator uses `size="xs"` (12px).
 *   - `Tag`'s built-in close/remove icon uses `size="xxs"` (10px), which sets the floor
 *     for the smallest glyph in this UI -- region chips are PANWDS `Tag`s, so their own
 *     close `x` is fixed at that size and is intentionally left alone.
 *   - `Button`'s leading `icon` slot is a `twds-w-5` grid cell; `size="sm"` (14px) is the
 *     largest glyph that sits in it without crowding, so the account menu's trigger and
 *     row icons use that.
 *
 * The trash and "+ Add Product" glyphs sit one step *below* the slot PANWDS reserves for
 * them (the icon-only slot is `twds-w-4`/16px, the leading-icon slot 20px). That is
 * deliberate: at slot size the trash visually outweighed the 12px chevron immediately to
 * its left, and the plus outweighed its own label. The wrapper span keeps its PANWDS
 * dimensions either way, so only the glyph shrinks and the hit area is unaffected.
 *
 * Centralizing them here means every compact icon in the modal resizes together instead
 * of drifting apart across `SubscribedProductPanel.jsx` / `AddProductSelect.jsx`.
 */
export const CHEVRON_ICON_SIZE = 'xs';
export const ADD_ICON_SIZE = 'xxs';
export const TRASH_ICON_SIZE = 'sm';
export const MENU_ICON_SIZE = 'sm';
